export function formatFileSize(bytes, t) {
  if (bytes >= 1024 * 1024) {
    return t('common.fileSizeMb', { size: (bytes / (1024 * 1024)).toFixed(1) });
  }
  return t('common.fileSizeKb', { size: Math.ceil(bytes / 1024) });
}
